import MenuLanguage from './MenuLanguage';

export default MenuLanguage;
